const Button = (props) => {
  return (
    <button className="btn btn-neutral" onClick={props.onClick}>
      <span>{props.text}</span>
    </button>
  );
};

export default Button;
